import HeaderProps from './_header-props';

class HeaderLogo {
    constructor() {
        if (!HeaderProps.$header) {
            return;
        }
        this.currentLogo = 'detailed';
        this.scrollYMargin = 10;

        this.$logoNormal = HeaderProps.$header.querySelector('[data-header-logo="normal"]');
        this.$logoDetailed = HeaderProps.$header.querySelector('[data-header-logo="detailed"]');

        this.setup();
    }
    setup(){
        document.addEventListener('scroll', () => {
            const isCollapsed = HeaderProps.$header.classList.contains('c-header--collapsed');
            if ((window.scrollY > this.scrollYMargin) && isCollapsed) {
                this.switchToNormalLogo();
            } else {
                this.switchToDetailedLogo();
            }
        })
    }
    switchToNormalLogo() {
        if (this.currentLogo === 'normal') {
            return;
        }
        this.currentLogo = 'normal';

        this.$logoNormal.classList.remove('c-header__logo--hidden');
        this.$logoDetailed.classList.add('c-header__logo--hidden');

    }
    switchToDetailedLogo() {
        if (this.currentLogo === 'detailed') {
            return;
        }
        this.currentLogo = 'detailed';

        this.$logoDetailed.classList.remove('c-header__logo--hidden');
        this.$logoNormal.classList.add('c-header__logo--hidden');
    }
}

export default new HeaderLogo();
